import { hamburger } from "../components/hamburger/hamburger";
import { lightbox } from "../components/image-gallery/image-gallery";
import { accordion } from "../components/accordion/accordion";
import { stickyHeader } from "../components/sticky-header/sticky-header";
import { scrollR } from "../components/scroll-reveal/scroll-reveal";

document.addEventListener("DOMContentLoaded", function () {
  hamburger();
  stickyHeader();
  accordion();
  lightbox();
  scrollR();
});
